import { UserStatusInfoRemoteDto } from 'src/generated/swagger/model/userStatusInfoRemoteDto';

declare global {
   interface Array<T> {
      sortUserStatusInfoRemoteDtos(): Array<T>;
   }
}

Array.prototype.sortUserStatusInfoRemoteDtos = function (): Array<UserStatusInfoRemoteDto> {
   return this.sort((a: UserStatusInfoRemoteDto, b: UserStatusInfoRemoteDto) => {
      // sort by status type, then by name
      if (a.type < b.type) {
         return -1;
      }
      if (a.type > b.type) {
         return 1;
      }
      return a.customStatusName?.localeCompare(b.customStatusName, undefined, { sensitivity: 'base' });
   });
};

export {};
